import { useState } from 'react';

export default function FreeAdvice() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d5j6gtuihetfqh7m5lig', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section id="free-advice" className="py-0 bg-white">
      <div className="grid lg:grid-cols-2">
        <div className="relative h-96 lg:h-auto min-h-[500px]">
          <img 
            src="https://public.readdy.ai/ai/img_res/b24f32688aa35be5eaf78e9ea33b6c58.jpg" 
            alt="Caribbean Sunset" 
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-[#C77A5A]/40"></div>
          <div className="absolute inset-0 flex flex-col justify-end p-12">
            <p className="text-xs uppercase tracking-wider text-white font-semibold mb-4">FREE CONSULTATION TO OPTIMIZE YOUR ONLYFANS PROFILE</p>
            <h2 className="text-4xl lg:text-5xl font-serif text-white leading-tight">
              Start Your<br />
              Success<br />
              Journey Today
            </h2>
          </div>
        </div>

        <div className="bg-white p-12 lg:p-16 flex items-center">
          <div className="w-full max-w-xl">
            <h3 className="text-3xl font-bold text-[#0F0F0F] mb-4">Get Your Free Strategy Session</h3>
            <p className="text-gray-600 leading-relaxed mb-8">
              Discover how Venezia Agency can transform your OnlyFans presence. Book a complimentary consultation with our experts and receive personalized insights for your growth.
            </p>

            <form id="free-advice-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                  className="w-full px-6 py-4 border-2 border-[#F6C1A1] rounded-lg focus:border-[#9B5E6B] focus:outline-none transition-colors duration-300 text-sm"
                />
              </div>

              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your Email"
                  required
                  className="w-full px-6 py-4 border-2 border-[#F6C1A1] rounded-lg focus:border-[#9B5E6B] focus:outline-none transition-colors duration-300 text-sm"
                />
              </div>

              <div>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  className="w-full px-6 py-4 border-2 border-[#F6C1A1] rounded-lg focus:border-[#9B5E6B] focus:outline-none transition-colors duration-300 text-sm"
                />
              </div>

              <div>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your goals..."
                  rows={4}
                  maxLength={500}
                  className="w-full px-6 py-4 border-2 border-[#F6C1A1] rounded-lg focus:border-[#9B5E6B] focus:outline-none transition-colors duration-300 resize-none text-sm"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 characters</p>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">
                  Thank you! We'll contact you soon.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                  Something went wrong. Please try again.
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-4 px-8 bg-[#F2A35E] text-white font-semibold rounded-lg hover:bg-[#C77A5A] transition-all duration-300 flex items-center justify-center group disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                <span>{isSubmitting ? 'Sending...' : 'Book Free Consultation'}</span>
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
